import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useGetUserOrganisations } from '../hooks/useGetUserOrganisations';
import { useAppSelector } from '../hooks/hooks';
import { Container, Spinner } from 'react-bootstrap';

export const SubscriptionCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const { refetch: reloadOrganisations } = useGetUserOrganisations(user?.id);
  const [showCheckoutComplete, setShowCheckoutComplete] = useState(false);

  useEffect(() => {
    const success = searchParams.get('success');
    const canceled = searchParams.get('canceled');
    const flow = searchParams.get('flow'); // e.g., 'upgrade' or 'signup'

    const handleSubscriptionResult = async () => {
      if (success === 'true') {
        try {
          await reloadOrganisations();
          // Redirect to a page where the user can see their updated plan, e.g., settings or billing.
          if (flow === 'upgrade') {
            navigate(`/settings?subscription_updated=true&flow=${flow}`);
          } else {
            setShowCheckoutComplete(true);
          }
        } catch (error) {
          console.error(
            'Failed to reload user data after subscription update:',
            error
          );
          // Redirect to an error page or back to the billing page with an error message
          navigate('/settings/billing?error=reload_failed');
        }
      } else if (canceled === 'true') {
        // Handle cancellation case, redirect back to the billing page with a cancellation indicator
        navigate('/settings');
      } else {
        // Handle failure case, redirect back to the billing page with a failure indicator
        navigate('/settings/billing?success=false');
      }
    };

    handleSubscriptionResult();
  }, [searchParams, navigate, reloadOrganisations]);

  // Display a loading spinner while processing the callback
  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      {showCheckoutComplete ? (
        <div className="text-center">
          <h2>Thank you for your subscription!</h2>
          <p>
            Your subscription has been successfully created. Please check your
            email for confirmation link and receipt.
          </p>
        </div>
      ) : (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
    </Container>
  );
};
